import { css } from 'styled-components';

export const stickyTopBarStyles = css<{ top?: number }>`
  background-color: ${({ theme }) => theme.colors.white};
  top: ${({ top }) => top}px;
  z-index: 4;
`;
